import { Component, useEffect, useState } from 'react';
import { Breadcrumb, Button, Row, Col, Popconfirm, Space, Table, Tag, Typography, Card, Skeleton, Avatar } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, DownloadOutlined, HomeOutlined, SettingOutlined, EditOutlined, EllipsisOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchCreatorsList } from '../../actions/admin';
import ManageEarningDrawer from './ManageEarningDrawer';


const { Text } = Typography;
const { Meta } = Card;

const CreatorsList = ({
    creatorListLoadingStatus,
    creatorList = [],
    fetchData,
}) => {

    const [selectedCreator, setSelectedCreator] = useState(null);

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            key: 'index',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Creator',
            render: creator => <Skeleton loading={false} avatar>
                <Link to={`/creators/${creator.id}`}>
                    <Meta
                        avatar={<Avatar src={creator.profilePicture} />}
                        title={`${creator.firstName} ${creator.lastName}`}
                        description={`${creator.username} [${creator.id}]`}
                    /></Link>
            </Skeleton>,
        },
        {
            title: 'Total Earnings',
            render: instance => <Text>US ${Number.isInteger(instance.totalEarnings) ? instance.totalEarnings : instance.totalEarnings.toFixed(2)}</Text>
        },
        {
            title: 'Pending Earnings',
            render: instance => {
                const pendingEarnings = instance.totalEarnings - instance.paidEarnings;
                return <Text>US ${Number.isInteger(pendingEarnings) ? pendingEarnings : pendingEarnings.toFixed(2)}</Text>
            }
        },
        {
            title: 'Action',
            fixed: 'right',
            width: 200,
            render: instance => {
                return (
                    <Button onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCreator(instance);
                    }}>
                        <Text color='success'>
                            <SettingOutlined /> Manage Earnings
                        </Text>
                    </Button>
                )
            },
        }
    ]

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <>
            <Table style={{ width: "100%" }} columns={columns} dataSource={creatorList.sort((a, b) => {
                const pendingA = a.totalEarnings - a.paidEarnings;
                const pendingB = b.totalEarnings - b.paidEarnings;
                return pendingB - pendingA; // descending
            })} pagination={false} loading={creatorListLoadingStatus === "LOADING"} rowKey={r => r.id} />

            {selectedCreator && (
                <ManageEarningDrawer
                    creator={selectedCreator}
                    visible={true}
                    onDrawerClose={(refresh) => {
                        if (refresh) {
                            fetchData();
                        }
                        setSelectedCreator(null)
                    }}
                />
            )}
        </>
    )
}




class CreatorEarningsList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div className="centered-container">
            <Space className="breadcrumbs">
                <Breadcrumb>
                    <Breadcrumb.Item>
                        <Link to="/"><HomeOutlined /></Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item><Link to="/admin">Admin Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item>Creator Earning</Breadcrumb.Item>
                </Breadcrumb>
            </Space>
            <br />
            <br />
            <div className="site-card-wrapper">
                <Row style={{ marginBottom: "1rem", width: "100%" }}>
                    <CreatorsList
                        creatorListLoadingStatus={this.props.creatorListLoadingStatus}
                        creatorList={this.props.creatorList}
                        fetchData={this.props.fetchCreatorsList}
                    ></CreatorsList>
                </Row>
            </div>
        </div>
    }
}

const mapStateToProps = state => {
    return {
        creatorList: state.adminReducer.creatorList,
        creatorListLoadingStatus: state.adminReducer.creatorListLoadingStatus
    }
}

export default connect(mapStateToProps, { fetchCreatorsList })(CreatorEarningsList);